import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./leftOffListings.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { calculateGridItemSize, calculateMaxRecords } from '../../../modules/helpers/gridItemHelper';
import { recentItemStore, selectWhereYouLeftOff } from '../../../modules/stores/recentItemStore';
import { userStore } from '../../../modules/stores/userStore';
import { getCookie } from '../../../modules/utilities/cookies';
class LeftOffListings extends LightningElement {
  constructor(...args) {
    super(...args);
    this.store = {
      isLoading: true,
      isError: false,
      isEmpty: false,
      records: []
    };
    // @ts-expect-error * Automated Type Error Fix
    this.gridItemSize = void 0;
    this.maxRecords = 9;
    // @ts-expect-error * Automated Type Error Fix
    this.variant = void 0;
    this._props = {};
  }
  setCurrentUser(userState) {
    const currentSid = this.sid;
    if (userState.isGuestUser) {
      this.sid = null;
    } else {
      this.sid = getCookie('sid');
    }
    const sidHasChanged = currentSid !== this.sid;
    if (sidHasChanged) {
      this.calculateSizes(userState.isGuestUser);
    }
  }
  calculateSizes(isGuestUser) {
    this.gridItemSize = calculateGridItemSize(isGuestUser, this._props);
    // if dims is empty 3 is max number of records
    this.maxRecords = calculateMaxRecords(isGuestUser, this._props, 3);
  }
  set props(value) {
    this._props = value;
    this.variant = value.variant;
    this.calculateSizes(userStore.getState().isGuestUser);
    this.fetchRecentItems();
  }
  get props() {
    return {
      format: 'listing',
      ...this._props
    };
  }
  fetchRecentItems() {
    const recentItemsInState = selectWhereYouLeftOff(recentItemStore.getState());
    if (recentItemsInState && recentItemsInState.length) {
      // @ts-expect-error * Automated Type Error Fix
      this.store.records = this.recentItemsToRecords(recentItemsInState);
    } else {
      recentItemStore.fetchRecentItems();
    }
  }
  get records() {
    return this.store.records.slice(0, this.maxRecords);
  }
  recentItemsToRecords(recentItems) {
    return recentItems.map(listing => ({
      ...listing,
      listingUrl: `${listing.listingUrl}&channel=recommended`
    }));
  }
  async setRecentItemsResults(recentItemState) {
    if (recentItemState) {
      const records = this.recentItemsToRecords(selectWhereYouLeftOff(recentItemState));
      this.store = {
        ...this.store,
        // @ts-expect-error * Automated Type Error Fix
        records,
        isLoading: false,
        isEmpty: records && records.length === 0
      };
    }
  }
  handleRetry() {
    this.fetchRecentItems();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LeftOffListings, {
  publicProps: {
    props: {
      config: 3
    }
  },
  track: {
    store: 1,
    gridItemSize: 1,
    maxRecords: 1,
    variant: 1
  },
  wire: {
    setCurrentUser: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore
        };
      }
    },
    setRecentItemsResults: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: recentItemStore
        };
      }
    }
  },
  fields: ["_props"]
});
const __lwc_component_class_internal = _registerComponent(LeftOffListings, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;